import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAvgShippingRevenuePerOrder = {
  name: "getAvgShippingRevenuePerOrder" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
